<template>
  <div class="vue gioca-vinci bg-dark">
    <div class="row" v-if="page === 'homepage'">
      <div class="col-lg-8 offset-lg-2 text-center py-5">
        <h2 class="mb-4" v-html="titleHtml"></h2>
        <p v-html="textLengthHtml" v-if="contests.length > 0"></p>
        <p v-html="textNoLengthHtml" v-else></p>
      </div>
    </div>
    <div class="header-dark py-5" v-else-if="page === 'giocavinci'">
      <div class="container text-center">
        <h1 class="mb-5" v-html="titleHtml"></h1>
        <user-cluster :border="true"></user-cluster>
        <h2 class="mb-5 mt-2">Concorsi Attivi</h2>
        <div class="row">
          <div class="col-sm-8 mx-3 mx-sm-0" style="margin: 0 auto !important; font-size: 1.1rem" v-html="textLengthHtml" v-if="contests.length > 0"></div>
          <div class="col-sm-8 mx-3 mx-sm-0" style="margin: 0 auto !important; font-size: 1.1rem" v-html="textNoLengthHtml" v-else></div>
<!--          <div class="col-sm-8 mx-3 mx-sm-0" style="margin: 0 auto !important; font-size: 1.1rem" v-html="textLengthHtml">Con TIM Party il divertimento non finisce mai. Abbiamo sempre pronte per te tante occasioni per giocare e vincere premi esclusivi.<br>Scopri i concorsi attivi e prova subito a giocare: oggi potrebbe essere il tuo giorno fortunato!</div>-->
        </div>
      </div>
    </div>
    <instant-win-slider :api-url="apiUrl" :catalog-url="catalogUrl" :excluded-codes='excludedCodes'></instant-win-slider>
  </div>
</template>
<script>

/* eslint-disable */

import UserCluster      from "@/components/UserCluster.vue";
import TimPartyMixin    from '../mixins/TimPartyMixin';
import InstantWinSlider from "@/components/InstantWinSlider.vue";
import 'slick-carousel';

export default {
  name: 'GiocaEVinci',
  mixins: [TimPartyMixin],
  components: {UserCluster, InstantWinSlider},
  props: {

    page: {
      type: String,
      required: true
    },
    titleHtml: {
      type: String,
      required: true
    },
    textLengthHtml: {
      type: String,
      required: true
    },
    textNoLengthHtml: {
      type: String,
      required: true
    },
    apiUrl: {
      type: String,
      required: true
    },
    catalogUrl: {
      type: String,
      required: false
    },
    excludedCodes: {
      type: Array,
      required: false
    },
    contestType: {
      type: String,
      required: false
    }

  },
  data: function () {
    return {
      contests: []
    };
  },
  mounted: function () {
    this.setApiUrl(this.apiUrl);

    this.now = Math.floor(new Date().getTime() / 1000);

    this.slider_id = this.slider_id + '-' + this.getRandomString(8);

    if (this.access_token) {
      this.getContests();
    }

  },
  methods: {
    getContests: function () {

      var self = this,
          payload_action;

      if (self.contestType == 'inactive') {
        payload_action = 'getAllInactive';
      }
      else {
        payload_action = 'getAllActive';
      }

      var payload = {
        action: payload_action,
        access_token: this.access_token
      };

      self.loading = true;
      this.callApi(payload, function (response) {


        self.loading = false;

        if (response.data != undefined) {
          self.contests = response.data;

          if (self.excludedCodes) {
            self.contests = _.filter(self.contests, function (item) {

              return (self.excludedCodes.indexOf(item.code) == -1);

            });
          }


          // keep only the contests with a url > node
          self.contests = _.filter(self.contests, function (item) {

            return (item.extra != undefined && item.extra.url)

          });

          let reordered = null;
          if (self.contestType == 'inactive') {
            reordered = self.contests.map((item) => {
              item.order = (item.endDate < self.now) ? (item.endDate * 2) : item.endDate;
              return item;
            }).sort(function (a, b) {
              return b.order - a.order;
            });
          }
          else {
            reordered = self.contests.map((item) => {
              item.order = (item.startDate < self.now) ? (item.startDate * 2) : item.startDate;
              return item;
            }).sort(function (a, b) {
              return b.order - a.order;
            });
          }

          self.contests = reordered;

          if (self.contests.length > 1) {
            self.activateSlider();
          }
        }

      });

    }
  },
  computed: {},
  watch: {
    access_token: function () {
      this.getContests();
    }
  }
}
</script>
